import { ValueObject } from './bitmap';
export interface Bin {
  width: number;
  height: number;
  data: string;
}


/**
 * 画图模式
 */
export enum DrawMode {
  /**
   * 普通
   */
  normal,
  /**
   * 左右对称
   */
  lrs,
  /**
   * 上下对称
   */
  uds,
  /**
   * 中心对称
   */
  centrosymmetry,

}

/**
 * 画图工具
 */
export enum DrawTool {
  /**
   * 铅笔
   */
  pancel = 'pancel',

  /**
   * 油漆桶
   */
  bucket = 'bucket',
}

export class BinValue implements Bin, ValueObject<Bin> {
  constructor(
    public readonly width: number,
    public readonly height: number,
    public readonly data: string,
  ) { }

  public static createNone(width: number, height: number) {
    return new BinValue(width, height, '');
  }

  eq(v: Bin): boolean {
    return this.width === v.width && this.height === v.height && this.data === v.data;
  }
  clone(): BinValue {
    return new BinValue(this.width, this.height, this.data);
  }
}


